import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { ServicePageActionTypes } from './types'
import { fetchSuccessService } from './actions'
import { callApi } from '../../utils/api'

function* handleFetch(action: any) {
	try {
		let code = action.payload.code;
		let filter = action.payload.filter as SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter;

		let params = '?code=' + code;

		if (filter.CountryCode) {
			params = params + '&CountryCode=' + filter.CountryCode;
		}
		if (filter.FamilyCode) {
			params = params + '&FamilyCode=' + filter.FamilyCode;
		}
		if (filter.InfotainmentCode) {
			params = params + '&InfotainmentCode=' + filter.InfotainmentCode;
		}
		if (filter.ProductionFromCode) {
			params = params + '&ProductionFromCode=' + filter.ProductionFromCode;
		}
		if (filter.ProductionToCode) {
			params = params + '&ProductionToCode=' + filter.ProductionToCode;
		}
		if (filter.ImporterBid) {
			params = params + '&ImporterBid=' + filter.ImporterBid;
		}
		if (filter.EnteredVin) {
			params = params + '&VinCode=' + filter.EnteredVin;
		}
		if (filter.Culture) {
			params = params + '&Culture=' + filter.Culture;
		}
		if (filter.VehicleMarketEntryCode) {
			params = params + '&VehicleMarketEntryCode=' + filter.VehicleMarketEntryCode;
		}

		const res: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ServiceModel = yield call(callApi, 'get', 'api/Availability/Service' + params)
		yield put(fetchSuccessService(res))
	}
	catch (err) {

	}
}

// This is our watcher function. We use `take*()` functions to watch Redux for a specific action
// type, and run our saga, for example the `handleFetch()` saga above.
function* watchFetchRequest() {
	yield takeEvery(ServicePageActionTypes.FETCH_REQUEST_Service, handleFetch)
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* servicePageSaga() {
	yield all([fork(watchFetchRequest)])
}

export default servicePageSaga
